<template>
  <div>
    <el-space wrap>
      <div class="img-box" v-for="(item, index) in imgArray" :key="item.id">
        <el-image @click="showImg(index) " style="width: 80px; height: 80px;cursor: pointer" fit="cover" :src="item.smallImg" ><template #error><div class="el-img-error">暂无图片</div></template></el-image>
        <div class="delIcon" @click="delImg(index)"><ElIcons name="CloseBold" color="#ffffff"/></div>
      </div>
      <div class="add" @click="fileUpdate">
        <span>+</span>
      </div>
    </el-space>
    <input type="file" accept=".jp2,.jpe,.jpeg,.jpg,.png,.heic"  @change="fileChanged" ref="file" multiple="multiple" style="display:none;">
    <div class="dialog-footer" style="text-align: center; margin-top: 24px;">
      <el-button @click.native="cancel" >取消</el-button>
      <el-button type="primary" @click="summit" v-loading="loading">确定</el-button>
    </div>
  </div>
</template>

<script>
import { imgPostFormData } from "@/api/api"
import { uploadUserImg, uploadCommodityImg, uploadStockTakeCommodityImg, uploadVisitImg } from "@/api/url";
import ImgViewer from "@/assets/js/imageViewer";

export default {
name: "UserImgUpload",
  props: {
    value: Object
  },
  data() {
    return {
      from: this.value.from, //1客户管理； 2商品管理； 3盘点记录; 4回访截图
      imgArray: this.value.imgArray,
      id: this.value.id,

      loading: false,
    }
  },
  methods: {

    showImg(idx) {
      let imgList = []
      for(let i=0; i<this.imgArray.length; i++) {
        imgList.push(this.imgArray[i].img)
      }
      ImgViewer.open({
        imgList: imgList,
        imgIndex: idx
      })
    },


    cancel() {
      this.$emit("close");
    },

    //更改或添加
    fileUpdate() {
      this.$refs.file.setAttribute('type', 'file')
      this.$refs.file.click();
    },

    //选取图片
    fileChanged(e) {
      if(e.target.files[0]) {
        for(let item of e.target.files) {
          let windowURL = window.URL || window.webkitURL;
          let src = windowURL.createObjectURL(item);
          let obj = {'img': src, 'smallImg': src, 'files': item};
          this.imgArray.push(obj);
        }
        this.$refs.file.setAttribute('type', 'text')
      }
    },

    // 删除图片
    delImg(idx) {
      if(this.imgArray[idx].id >= 0) {
        this.delImgIdArray.push(this.imgArray[idx].id);
      }
      this.imgArray.splice(idx,1);
    },


    summit() {
      if(this.imgArray.length == 0) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '请选择上传的图片',
          type: 'warning'
        });
        return false
      }
      this.loading = true
      let _this = this
      let param = new FormData();
      param.append('id', this.id);
      for(let i = 0; i < this.imgArray.length; i++) {
        if(!this.imgArray[i].id) {
          param.append('file' + i, this.imgArray[i].files);
        }
      }
      imgPostFormData(this.from == 1?uploadUserImg:this.from == 2?uploadCommodityImg:this.from == 3?uploadStockTakeCommodityImg:this.from == 4?uploadVisitImg:'', param).then((data) => {
        let {msg, code} = data
        if (code == 200) {
          _this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'success'
          });
          _this.$emit('confirm')
        }else {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'warning'
          });
        }
        _this.loading = false
      }).catch(()=>{
        _this.loading = false
      })
    },


  },
  mounted() {
    console.log(this.from)
  }
}
</script>

<style scoped>
.add {
  width: 80px;
  height: 80px;
  text-align: center;
  line-height: 80px;
  border: 1px dashed #ececec;
  font-size: 30px;
  cursor: pointer;
  float: left;
}
.img-box {
  width: 80px;
  height: 80px;
  position: relative;
}
.delIcon {
  background-color: rgba(0,0,0,0.8);
  width: 20px;
  height: 20px;
  position: absolute;
  top: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
</style>
